import Axios from 'axios'

import { CreateGroupBody, TGroupApi } from 'types/GlobalGroup'

import { getWithRedirect } from 'utils/axios'
import { parseAuthenticationHeader } from 'helpers/Functions'
import { ShowPerEnum } from 'types/GlobalMetric'
import { RollingType } from 'types/GlobalKpiOption'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/groups`

export type TPostGroupMetric = {
  kpi_template_id: string
  variant_kpi_template_id: string | null
  rolling_sum: RollingType | null
  distribution: ShowPerEnum | null
  slices: string[]
}

export async function getAll() {
  return getWithRedirect<TGroupApi[]>(URL)
}

export async function create(body: CreateGroupBody) {
  return Axios.post<{ data: TGroupApi }>(
    URL,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function update(id: string, body: Partial<CreateGroupBody>) {
  return Axios.patch<{ data: TGroupApi }>(
    `${URL}/${id}`,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function invite(id: string, accounts: string[], notify: boolean) {
  return Axios.post<{ data: TGroupApi }>(
    `${URL}/${id}/invite`,
    { data: { accounts, notify } },
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}

export async function addKeyMetric(id: string, keyMetricId: string) {
  return Axios.post(
    `${URL}/${id}/key-metrics/${keyMetricId}`,
    {},
    parseAuthenticationHeader()
  )
}

export async function addMetric(id: string, data: TPostGroupMetric) {
  return Axios.post(
    `${URL}/${id}/metrics`,
    { data },
    parseAuthenticationHeader()
  )
}

export async function removeKeyMetric(id: string, keyMetricId: string) {
  return Axios.delete(
    `${URL}/${id}/key-metrics/${keyMetricId}`,
    parseAuthenticationHeader()
  )
}

export async function removeMetric(id: string, groupMetricId: string) {
  return Axios.delete(
    `${URL}/${id}/metrics/${groupMetricId}`,
    parseAuthenticationHeader()
  )
}

export async function updateMetricOrder(
  id: string,
  body: { id: string; index: number }[]
) {
  return Axios.put(
    `${URL}/${id}/metric-order`,
    { data: body },
    parseAuthenticationHeader()
  )
}
export async function updateKeyMetricOrder(
  id: string,
  body: { key_metric_id: string; index: number }[]
) {
  return Axios.put(
    `${URL}/${id}/key-metric-order`,
    { data: body },
    parseAuthenticationHeader()
  )
}
